import type { SVGProps } from "react";

export const Bamboohr = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="Layer_1"
    style={{}}
    version="1.1"
    viewBox="0 0 133.5 105"
    x="0px"
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    y="0px"
    {...props}
  >
    <title>Bamboohr</title>

    <desc>Created with Sketch.</desc>
    <g id="Page-1">
      <g id="Marketplace">
        <g id="Logo_x2F_BambooHR_x2F_Logo">
          <path
            d="M97.5,32.3c19.3,0,36,16.6,36,35.8c0,20.8-16,36.9-37.2,36.9c-19.2,0-35.9-13.4-35.9-35V0     h11.1l0,42.8l1.3-1.4C77.7,36.7,84.6,32.3,97.5,32.3z M96.4,94.9c15.8,0,25.8-11.1,25.8-25.8c0-13.5-9.5-26.4-25.5-26.4     c-16.1,0-26,12-26,26.7C70.6,84,82.4,94.9,96.4,94.9z M38.2,8.5c8.3,8.7,9.2,13.5,12.1,22l4.9,16c0,0-4.9-0.9-8.9-1.5     c-4.6-0.7-6.7-1.4-12.6-3.8c-5.9-2.4-11.2-8.2-16.4-14.7C12.2,20.1,0,9.9,0,9.9s3.8,0.2,7.6,1.2c3.1,0.8,11.3,3.4,19.7,7.7     c1.9,1,2.9,1.6,4.7,2.7c2.8,1.7,5.7,4.3,8.5,7.1c3.3,3.3,6.2,6,8.7,9c-2.7-4.9-9.7-22.6-23.3-37.2C24.6-1.1,35.3,5.5,38.2,8.5z"
            id="BambooHR"
            style={{ fill: "#73C41D" }}
          />
        </g>
      </g>
    </g>
  </svg>
);

export default Bamboohr;
